import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from 'src/layouts/AppLayout'
import NotFound from 'src/layouts/NotFound'
import { About, Contact, Home, Skills, Works } from 'src/pages'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: '',
        component: Home,
        meta: { title: 'Home | KAZUMA USUI' }
      },
      {
        path: 'about',
        component: About,
        meta: { title: 'About | KAZUMA USUI' }
      },
      {
        path: 'contact',
        component: Contact,
        meta: { title: 'Contact | KAZUMA USUI' }
      },
      {
        path: 'skills',
        component: Skills,
        meta: { title: 'Skills | KAZUMA USUI' }
      },
      {
        path: 'works',
        component: Works,
        meta: { title: 'Works | KAZUMA USUI' }
      }
    ]
  },
  {
    path: '*',
    component: NotFound,
    meta: { title: 'NotFound | KAZUMA USUI' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.afterEach(to => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
